<div class="avatar-stack-container"
     [attr.data-size]="size"
     [attr.data-shape]="shape"
     [attr.data-spacing]="spacing"
     [attr.data-disabled]="disabled">
  
  <!-- Visible avatars -->
  <div *ngFor="let avatar of visibleAvatars; let i = index; trackBy: trackByIndex"
       class="avatar-wrapper"
       [attr.data-index]="i">
    <umss-avatar
      [src]="avatar.src"
      [name]="avatar.name"
      [initials]="avatar.initials"
      [status]="avatar.status"
      [size]="size"
      [shape]="shape"
      [disabled]="disabled">
    </umss-avatar>
  </div>

  <!-- Remaining count badge -->
  <div *ngIf="hasRemaining" 
       class="avatar-wrapper avatar-count"
       [attr.data-index]="maxVisible">
    <div class="count-badge"
         [attr.data-size]="size"
         [attr.data-shape]="shape">
      +{{ remainingCount }}
    </div>
  </div>
</div>